<template>
    <div>

        <div class="container section">
            <div class="row ">
                <div class="col-4">
                    <h2>Telno Lookup History</h2>
                </div>
            </div>
            <div class="row ">
                <div class="col-4">
                    <form @submit.prevent="check">
                        <div class="input-group">
                            <input type="text" v-model="telno" class="form-control" />&nbsp;
                            <button class="btn btn-primary">Search</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="container section text-center" v-show="loading">
            <pulse-loader v-show="loading" color="#5e9cd3"></pulse-loader>
        </div>


        <div class="container section" v-show="found">
            <div class="row table-head ">
                <div class="col-6 col-sm-3 col-md-2">Lookup Time</div>
                <div class="col-6 col-sm-9 col-md-10">Carrier</div>
            </div>
            <div class="row lined" v-for="carrier in carriers">
                <div class="col-6 col-sm-3 col-md-2">{{carrier.timestamp | formatDate }}</div>
                <div class="col-6 col-sm-9 col-md-10">{{carrier.carrierName}}</div>
            </div>

        </div>
    </div>

</template>
<script type="text/babel">
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    export default{
        data(){
            return {
                telno:'',
                carriers: [],
                found: false,
                loading: false


            }
        },
        created(){

            console.log(this.$route.query.telno);
            this.telno =  this.$route.query.telno || null;

            if( this.telno ) this.check();

        },
        filters:{
            formatDate(val){
               return  moment(val).format('MM/DD/YYYY hh:mm a')
            }
        },
        components:{
            PulseLoader
        },
        methods:{
            check(){
                this.loading = true;
                this.found = false;
                this.$send(this, 'telnoLookup', { telno: this.telno}).then(r => {
                    this.found = true;
                    this.loading = false;

                   this.carriers = r.telnoLookup;
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// TelnoLookup.vue?f96fcfdc